
import { ChevronDownIcon, XCircleFillIcon } from '@primer/octicons-react';
import { Box, Button, Checkbox, FormControl, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCommonContext } from '../../contexts/common';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { noitru_phong_namhoc } from '../../models/response/category/noitru_phong_namhoc';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
type ISelectBoxPhongNamHocMultipleProps = {
	isReadonly?: boolean;
	ignore_id?: number,
	value: number[];
	onValueChanged: (id: number[], lops?: noitru_phong_namhoc[]) => void;
	className?: string;
	preText?: string;
	width?: string | number;
	dm_khoi_id?: number;
	dm_truong_id?: number;
	dm_he_id?: number;
	nam_hoc?: string;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
	isShowClearBtn?: boolean,
	maxWidth?: any
};
const SelectBoxPhongNamHocMultiple = (props: ISelectBoxPhongNamHocMultipleProps) => {
	const { translate } = useCommonContext();
	const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
	const dispatch = useDispatch();
	const { status: phongNamHocStatus, noitru_phong_namhocs } = useSelector((x: RootState) => x.danhMucWrapper.phongNamHoc);

	useEffect(() => {
		dispatch(actions.danhMucWrapper.phongNamHoc.selectStart());
	}, [nam_hoc, dm_coso_id])


	const phongNamHocFilters: any[] = useMemo(() => {
		return noitru_phong_namhocs 
		// && props.nam_hoc && props.dm_truong_id
			? noitru_phong_namhocs.sort((a, b) => (a.ten_phong > b.ten_phong) ? 1 : -1)
			: [];
	}, [noitru_phong_namhocs]);
	const [filter, setFilter] = useState('')
	const [open, setOpen] = useState(false)
	const dataSource = useMemo(() => {
		console.log(noitru_phong_namhocs
		.filter(x => x.dm_coso_id === dm_coso_id)
		)
		return noitru_phong_namhocs
		.filter(x => x.dm_coso_id === dm_coso_id)
		.map(x => {
			const item: any = {
				id: x.id,
				text: x.ten_phong,
			}
			console.log(item)
			return item;
		})
	}, [phongNamHocFilters, filter, dm_coso_id])
	const filterdData = useMemo(() => {
		return dataSource.filter(item =>
			item.text.toLowerCase().includes(filter.toLowerCase())
		)
	}, [dataSource, filter])
	const _selectedDatas = useMemo(() => {
		return dataSource.filter(item => props.value && props.value.includes(item.id))
	}, [props.value, dataSource])
	const isSelectedAll = filterdData.length > 0 && filterdData.map(x => x.id).find(id => !props.value.includes(id)) === undefined;
	return (
		<SelectPanel
			renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
				<Button sx={{
					maxWidth: 300
				}}
					trailingAction={ChevronDownIcon}
					aria-labelledby={` ${ariaLabelledBy}`} {...anchorProps}>
					<p style={{ maxWidth: props.maxWidth, overflow: "hidden", textOverflow: "ellipsis" }}>
						{children || 'Chọn phòng'}
					</p>
				</Button>
			)}
			title={<>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Box sx={{ flex: 1 }}>
						<FormControl>
							<Checkbox checked={isSelectedAll} onChange={(e) => {
								if (e.target.checked) {
									props.onValueChanged(filterdData.map(x => x.id), noitru_phong_namhocs)
								} else {
									props.onValueChanged([])
								}
							}} />
							<FormControl.Label>Select all</FormControl.Label>
						</FormControl>
					</Box>
					{props.isShowClearBtn && props.value.length > 0 &&
						<Button
							trailingVisual={XCircleFillIcon}
							variant='invisible'
							sx={{
								color: "danger.emphasis"
							}}
							onClick={() => {
								props.onValueChanged([])
							}}
						>
							Bỏ chọn
						</Button>
					}
				</Box>
			</>}
			placeholderText="Search"
			open={open}
			onOpenChange={setOpen}
			items={filterdData}
			selected={_selectedDatas}
			onSelectedChange={(data: any) => {
				const ids: number[] = data.map((x: any) => x.id);
				props.onValueChanged(ids, noitru_phong_namhocs.filter(x => ids.includes(x.id)))
			}}
			onFilterChange={setFilter}
			showItemDividers={true}
			overlayProps={{ width: 'medium', height: 'medium' }}
		/>

	);
};

export default SelectBoxPhongNamHocMultiple;
